import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09b7b384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Mensajes del grupo:", -1))
const _hoisted_3 = { class: "list-group-item-success reverseorder" }
const _hoisted_4 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_card_group = _resolveComponent("b-card-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentGroup.messages || [], (message) => {
        return (_openBlock(), _createElementBlock("li", {
          key: message,
          class: "container__list items-list"
        }, [
          _createVNode(_component_b_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_b_card_group, { deck: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_card, {
                      "bg-variant": "light",
                      header: new Date(message.time).toLocaleString(),
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_card_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message.message), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["header"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}